// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================
   PREMIUM TRENDING SECTION - BENTO GRID
============================ */

.trending-section {
    padding: 120px 0;
    position: relative;
    overflow: hidden;
}

/* ============================
   SECTION HEADER
============================ */

.section-header {
    text-align: center;
    margin-bottom: 80px;
    animation: fadeInUp 0.8s ease-out;
}

.section-badge {
    display: inline-block;
    padding: 8px 20px;
    background: rgba(99, 102, 241, 0.15);
    border: 1px solid rgba(139, 92, 246, 0.4);
    border-radius: 50px;
    color: rgba(255, 255, 255, 0.95);
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 24px;
    text-transform: uppercase;
    letter-spacing: 0.05em;
    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);
}

.section-title {
    font-size: clamp(2rem, 4vw, 3.5rem);
    font-weight: 700;
    color: #ffffff;
    margin-bottom: 16px;
    letter-spacing: -0.02em;
    line-height: 1.2;
}

.gradient-text {
    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

@keyframes fadeInUp {
    from {
        opacity: 0;
        transform: translateY(20px);
    }
    to {
        opacity: 1;
        transform: translateY(0);
    }
}

/* ============================
   TRENDING GRID - MASONRY STYLE
============================ */

.trending-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 30px;
    max-width: 1200px;
    margin: 0 auto;
}

/* ============================
   TRENDING CARD - IMAGE FOCUSED
============================ */

.trending-card {
    position: relative;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));
    border: 2px solid rgba(139, 92, 246, 0.3);
    border-radius: 24px;
    padding: 0;
    overflow: hidden;
    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);
    cursor: pointer;
    animation: fadeInUp 0.6s ease-out both;
}

.trending-card[data-index="0"] { 
    animation-delay: 0.1s;
    grid-row: span 1;
}
.trending-card[data-index="1"] { 
    animation-delay: 0.2s;
    grid-row: span 1;
}
.trending-card[data-index="2"] { 
    animation-delay: 0.3s;
    grid-row: span 1;
}
.trending-card[data-index="3"] { 
    animation-delay: 0.4s;
    grid-row: span 1;
}
.trending-card[data-index="4"] { 
    animation-delay: 0.5s;
    grid-row: span 1;
}
.trending-card[data-index="5"] { 
    animation-delay: 0.6s;
    grid-row: span 1;
}

.trending-card::before {
    content: '';
    position: absolute;
    inset: 0;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.1));
    opacity: 0;
    transition: opacity 0.5s ease;
    z-index: 1;
}

.trending-card:hover::before {
    opacity: 1;
}

.trending-card:hover {
    transform: translateY(-12px) scale(1.03);
    border-color: rgba(168, 85, 247, 0.6);
    box-shadow: 
        0 30px 70px rgba(99, 102, 241, 0.3),
        0 0 80px rgba(168, 85, 247, 0.2);
}

/* ============================
   IMAGE CONTAINER
============================ */

.trending-image-wrapper {
    width: 100%;
    height: 200px;
    position: relative;
    overflow: hidden;
    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.1));
}

.trending-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);
    filter: brightness(0.8) saturate(1.2);
}

.trending-card:hover .trending-image {
    transform: scale(1.1);
    filter: brightness(1) saturate(1.4);
}

/* ============================
   OVERLAY GRADIENT
============================ */

.image-overlay {
    position: absolute;
    inset: 0;
    background: linear-gradient(to bottom, 
        transparent 0%,
        rgba(5, 7, 12, 0.6) 70%,
        rgba(5, 7, 12, 0.9) 100%
    );
    z-index: 1;
}

/* ============================
   CARD CONTENT
============================ */

.trending-content {
    padding: 24px 28px 28px;
    position: relative;
    z-index: 2;
}

/* ============================
   NUMBER BADGE
============================ */

.card-number-badge {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 42px;
    height: 42px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(5, 7, 12, 0.8);
    backdrop-filter: blur(10px);
    border: 2px solid rgba(255, 255, 255, 0.3);
    border-radius: 12px;
    font-size: 1.125rem;
    font-weight: 800;
    color: #ffffff;
    z-index: 3;
    transition: all 0.4s ease;
}

.trending-card:hover .card-number-badge {
    background: linear-gradient(135deg, #6366f1, #a855f7);
    transform: scale(1.15) rotate(-5deg);
    box-shadow: 0 4px 15px rgba(168, 85, 247, 0.5);
}

/* ============================
   TITLE
============================ */

.trending-name {
    font-size: 1.5rem;
    font-weight: 700;
    color: #ffffff;
    margin: 0;
    position: relative;
    z-index: 2;
    transition: all 0.3s ease;
    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);
}

.trending-card:hover .trending-name {
    background: linear-gradient(135deg, #818cf8, #c084fc);
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    background-clip: text;
}

/* ============================
   ARROW INDICATOR
============================ */

.card-arrow {
    position: absolute;
    bottom: 24px;
    right: 24px;
    width: 40px;
    height: 40px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(99, 102, 241, 0.2);
    backdrop-filter: blur(10px);
    border-radius: 50%;
    color: rgba(255, 255, 255, 0.8);
    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);
    z-index: 3;
}

.trending-card:hover .card-arrow {
    background: linear-gradient(135deg, #6366f1, #a855f7);
    color: #ffffff;
    transform: translate(6px, -6px) scale(1.1);
    box-shadow: 0 6px 20px rgba(168, 85, 247, 0.4);
}

/* ============================
   SHINE EFFECT
============================ */

.card-shimmer {
    position: absolute;
    top: -50%;
    left: -50%;
    width: 200%;
    height: 200%;
    background: linear-gradient(45deg, 
        transparent 30%,
        rgba(255, 255, 255, 0.15) 50%,
        transparent 70%
    );
    transform: rotate(45deg);
    opacity: 0;
    transition: all 0.8s ease;
    z-index: 2;
    pointer-events: none;
}

.trending-card:hover .card-shimmer {
    opacity: 1;
    animation: shimmerPass 1.5s ease-out;
}

@keyframes shimmerPass {
    from {
        transform: translateX(-100%) rotate(45deg);
    }
    to {
        transform: translateX(100%) rotate(45deg);
    }
}

/* ============================
   RESPONSIVE
============================ */

@media (max-width: 992px) {
    .trending-grid {
        grid-template-columns: repeat(2, 1fr);
        gap: 24px;
    }
}

@media (max-width: 768px) {
    .trending-section {
        padding: 80px 0;
    }

    .section-header {
        margin-bottom: 60px;
    }

    .trending-image-wrapper {
        height: 160px;
    }

    .trending-content {
        padding: 20px 24px 24px;
    }

    .trending-name {
        font-size: 1.25rem;
    }

    .card-number-badge {
        width: 36px;
        height: 36px;
        font-size: 1rem;
    }
}

@media (max-width: 576px) {
    .trending-grid {
        grid-template-columns: 1fr;
    }

    .trending-image-wrapper {
        height: 180px;
    }
}
`, "",{"version":3,"sources":["webpack://./src/components/TopTrending.css"],"names":[],"mappings":"AAAA;;8BAE8B;;AAE9B;IACI,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,mBAAmB;IACnB,iCAAiC;AACrC;;AAEA;IACI,qBAAqB;IACrB,iBAAiB;IACjB,oCAAoC;IACpC,yCAAyC;IACzC,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,yBAAyB;IACzB,sBAAsB;IACtB,8CAA8C;AAClD;;AAEA;IACI,mCAAmC;IACnC,gBAAgB;IAChB,cAAc;IACd,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,8DAA8D;IAC9D,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;IACI;QACI,UAAU;QACV,2BAA2B;IAC/B;IACA;QACI,UAAU;QACV,wBAAwB;IAC5B;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI,aAAa;IACb,qCAAqC;IACrC,SAAS;IACT,iBAAiB;IACjB,cAAc;AAClB;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,sFAAsF;IACtF,yCAAyC;IACzC,mBAAmB;IACnB,UAAU;IACV,gBAAgB;IAChB,kDAAkD;IAClD,eAAe;IACf,sCAAsC;AAC1C;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;AACA;IACI,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,QAAQ;IACR,qFAAqF;IACrF,UAAU;IACV,6BAA6B;IAC7B,UAAU;AACd;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,wCAAwC;IACxC,qCAAqC;IACrC;;wCAEoC;AACxC;;AAEA;;8BAE8B;;AAE9B;IACI,WAAW;IACX,aAAa;IACb,kBAAkB;IAClB,gBAAgB;IAChB,sFAAsF;AAC1F;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,kDAAkD;IAClD,qCAAqC;AACzC;;AAEA;IACI,qBAAqB;IACrB,mCAAmC;AACvC;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,QAAQ;IACR;;;;KAIC;IACD,UAAU;AACd;;AAEA;;8BAE8B;;AAE9B;IACI,uBAAuB;IACvB,kBAAkB;IAClB,UAAU;AACd;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,SAAS;IACT,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,2BAA2B;IAC3B,0CAA0C;IAC1C,mBAAmB;IACnB,mBAAmB;IACnB,gBAAgB;IAChB,cAAc;IACd,UAAU;IACV,yBAAyB;AAC7B;;AAEA;IACI,qDAAqD;IACrD,oCAAoC;IACpC,8CAA8C;AAClD;;AAEA;;8BAE8B;;AAE9B;IACI,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,SAAS;IACT,kBAAkB;IAClB,UAAU;IACV,yBAAyB;IACzB,0CAA0C;AAC9C;;AAEA;IACI,qDAAqD;IACrD,6BAA6B;IAC7B,oCAAoC;IACpC,qBAAqB;AACzB;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,YAAY;IACZ,WAAW;IACX,WAAW;IACX,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,mCAAmC;IACnC,2BAA2B;IAC3B,kBAAkB;IAClB,+BAA+B;IAC/B,kDAAkD;IAClD,UAAU;AACd;;AAEA;IACI,qDAAqD;IACrD,cAAc;IACd,0CAA0C;IAC1C,8CAA8C;AAClD;;AAEA;;8BAE8B;;AAE9B;IACI,kBAAkB;IAClB,SAAS;IACT,UAAU;IACV,WAAW;IACX,YAAY;IACZ;;;;KAIC;IACD,wBAAwB;IACxB,UAAU;IACV,yBAAyB;IACzB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,UAAU;IACV,oCAAoC;AACxC;;AAEA;IACI;QACI,0CAA0C;IAC9C;IACA;QACI,yCAAyC;IAC7C;AACJ;;AAEA;;8BAE8B;;AAE9B;IACI;QACI,qCAAqC;QACrC,SAAS;IACb;AACJ;;AAEA;IACI;QACI,eAAe;IACnB;;IAEA;QACI,mBAAmB;IACvB;;IAEA;QACI,aAAa;IACjB;;IAEA;QACI,uBAAuB;IAC3B;;IAEA;QACI,kBAAkB;IACtB;;IAEA;QACI,WAAW;QACX,YAAY;QACZ,eAAe;IACnB;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;;IAEA;QACI,aAAa;IACjB;AACJ","sourcesContent":["/* ============================\n   PREMIUM TRENDING SECTION - BENTO GRID\n============================ */\n\n.trending-section {\n    padding: 120px 0;\n    position: relative;\n    overflow: hidden;\n}\n\n/* ============================\n   SECTION HEADER\n============================ */\n\n.section-header {\n    text-align: center;\n    margin-bottom: 80px;\n    animation: fadeInUp 0.8s ease-out;\n}\n\n.section-badge {\n    display: inline-block;\n    padding: 8px 20px;\n    background: rgba(99, 102, 241, 0.15);\n    border: 1px solid rgba(139, 92, 246, 0.4);\n    border-radius: 50px;\n    color: rgba(255, 255, 255, 0.95);\n    font-size: 0.875rem;\n    font-weight: 600;\n    margin-bottom: 24px;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n    box-shadow: 0 4px 20px rgba(99, 102, 241, 0.2);\n}\n\n.section-title {\n    font-size: clamp(2rem, 4vw, 3.5rem);\n    font-weight: 700;\n    color: #ffffff;\n    margin-bottom: 16px;\n    letter-spacing: -0.02em;\n    line-height: 1.2;\n}\n\n.gradient-text {\n    background: linear-gradient(135deg, #818cf8, #c084fc, #f472b6);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n@keyframes fadeInUp {\n    from {\n        opacity: 0;\n        transform: translateY(20px);\n    }\n    to {\n        opacity: 1;\n        transform: translateY(0);\n    }\n}\n\n/* ============================\n   TRENDING GRID - MASONRY STYLE\n============================ */\n\n.trending-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 30px;\n    max-width: 1200px;\n    margin: 0 auto;\n}\n\n/* ============================\n   TRENDING CARD - IMAGE FOCUSED\n============================ */\n\n.trending-card {\n    position: relative;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.1), rgba(168, 85, 247, 0.05));\n    border: 2px solid rgba(139, 92, 246, 0.3);\n    border-radius: 24px;\n    padding: 0;\n    overflow: hidden;\n    transition: all 0.5s cubic-bezier(0.16, 1, 0.3, 1);\n    cursor: pointer;\n    animation: fadeInUp 0.6s ease-out both;\n}\n\n.trending-card[data-index=\"0\"] { \n    animation-delay: 0.1s;\n    grid-row: span 1;\n}\n.trending-card[data-index=\"1\"] { \n    animation-delay: 0.2s;\n    grid-row: span 1;\n}\n.trending-card[data-index=\"2\"] { \n    animation-delay: 0.3s;\n    grid-row: span 1;\n}\n.trending-card[data-index=\"3\"] { \n    animation-delay: 0.4s;\n    grid-row: span 1;\n}\n.trending-card[data-index=\"4\"] { \n    animation-delay: 0.5s;\n    grid-row: span 1;\n}\n.trending-card[data-index=\"5\"] { \n    animation-delay: 0.6s;\n    grid-row: span 1;\n}\n\n.trending-card::before {\n    content: '';\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.2), rgba(168, 85, 247, 0.1));\n    opacity: 0;\n    transition: opacity 0.5s ease;\n    z-index: 1;\n}\n\n.trending-card:hover::before {\n    opacity: 1;\n}\n\n.trending-card:hover {\n    transform: translateY(-12px) scale(1.03);\n    border-color: rgba(168, 85, 247, 0.6);\n    box-shadow: \n        0 30px 70px rgba(99, 102, 241, 0.3),\n        0 0 80px rgba(168, 85, 247, 0.2);\n}\n\n/* ============================\n   IMAGE CONTAINER\n============================ */\n\n.trending-image-wrapper {\n    width: 100%;\n    height: 200px;\n    position: relative;\n    overflow: hidden;\n    background: linear-gradient(135deg, rgba(99, 102, 241, 0.15), rgba(168, 85, 247, 0.1));\n}\n\n.trending-image {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    transition: all 0.6s cubic-bezier(0.16, 1, 0.3, 1);\n    filter: brightness(0.8) saturate(1.2);\n}\n\n.trending-card:hover .trending-image {\n    transform: scale(1.1);\n    filter: brightness(1) saturate(1.4);\n}\n\n/* ============================\n   OVERLAY GRADIENT\n============================ */\n\n.image-overlay {\n    position: absolute;\n    inset: 0;\n    background: linear-gradient(to bottom, \n        transparent 0%,\n        rgba(5, 7, 12, 0.6) 70%,\n        rgba(5, 7, 12, 0.9) 100%\n    );\n    z-index: 1;\n}\n\n/* ============================\n   CARD CONTENT\n============================ */\n\n.trending-content {\n    padding: 24px 28px 28px;\n    position: relative;\n    z-index: 2;\n}\n\n/* ============================\n   NUMBER BADGE\n============================ */\n\n.card-number-badge {\n    position: absolute;\n    top: 16px;\n    right: 16px;\n    width: 42px;\n    height: 42px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(5, 7, 12, 0.8);\n    backdrop-filter: blur(10px);\n    border: 2px solid rgba(255, 255, 255, 0.3);\n    border-radius: 12px;\n    font-size: 1.125rem;\n    font-weight: 800;\n    color: #ffffff;\n    z-index: 3;\n    transition: all 0.4s ease;\n}\n\n.trending-card:hover .card-number-badge {\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    transform: scale(1.15) rotate(-5deg);\n    box-shadow: 0 4px 15px rgba(168, 85, 247, 0.5);\n}\n\n/* ============================\n   TITLE\n============================ */\n\n.trending-name {\n    font-size: 1.5rem;\n    font-weight: 700;\n    color: #ffffff;\n    margin: 0;\n    position: relative;\n    z-index: 2;\n    transition: all 0.3s ease;\n    text-shadow: 0 2px 10px rgba(0, 0, 0, 0.5);\n}\n\n.trending-card:hover .trending-name {\n    background: linear-gradient(135deg, #818cf8, #c084fc);\n    -webkit-background-clip: text;\n    -webkit-text-fill-color: transparent;\n    background-clip: text;\n}\n\n/* ============================\n   ARROW INDICATOR\n============================ */\n\n.card-arrow {\n    position: absolute;\n    bottom: 24px;\n    right: 24px;\n    width: 40px;\n    height: 40px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(99, 102, 241, 0.2);\n    backdrop-filter: blur(10px);\n    border-radius: 50%;\n    color: rgba(255, 255, 255, 0.8);\n    transition: all 0.4s cubic-bezier(0.16, 1, 0.3, 1);\n    z-index: 3;\n}\n\n.trending-card:hover .card-arrow {\n    background: linear-gradient(135deg, #6366f1, #a855f7);\n    color: #ffffff;\n    transform: translate(6px, -6px) scale(1.1);\n    box-shadow: 0 6px 20px rgba(168, 85, 247, 0.4);\n}\n\n/* ============================\n   SHINE EFFECT\n============================ */\n\n.card-shimmer {\n    position: absolute;\n    top: -50%;\n    left: -50%;\n    width: 200%;\n    height: 200%;\n    background: linear-gradient(45deg, \n        transparent 30%,\n        rgba(255, 255, 255, 0.15) 50%,\n        transparent 70%\n    );\n    transform: rotate(45deg);\n    opacity: 0;\n    transition: all 0.8s ease;\n    z-index: 2;\n    pointer-events: none;\n}\n\n.trending-card:hover .card-shimmer {\n    opacity: 1;\n    animation: shimmerPass 1.5s ease-out;\n}\n\n@keyframes shimmerPass {\n    from {\n        transform: translateX(-100%) rotate(45deg);\n    }\n    to {\n        transform: translateX(100%) rotate(45deg);\n    }\n}\n\n/* ============================\n   RESPONSIVE\n============================ */\n\n@media (max-width: 992px) {\n    .trending-grid {\n        grid-template-columns: repeat(2, 1fr);\n        gap: 24px;\n    }\n}\n\n@media (max-width: 768px) {\n    .trending-section {\n        padding: 80px 0;\n    }\n\n    .section-header {\n        margin-bottom: 60px;\n    }\n\n    .trending-image-wrapper {\n        height: 160px;\n    }\n\n    .trending-content {\n        padding: 20px 24px 24px;\n    }\n\n    .trending-name {\n        font-size: 1.25rem;\n    }\n\n    .card-number-badge {\n        width: 36px;\n        height: 36px;\n        font-size: 1rem;\n    }\n}\n\n@media (max-width: 576px) {\n    .trending-grid {\n        grid-template-columns: 1fr;\n    }\n\n    .trending-image-wrapper {\n        height: 180px;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
